import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import AdminPage from "@/pages/Admin";
import { LanguageProvider } from "@/i18n";
import { PrivacyPolicy, Terms, PaymentDisclosure } from "@/pages/Legal";
import PayPage from "@/pages/Pay";
import PaymentSuccessPage from "@/pages/PaymentSuccess";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/payment-disclosure" element={<PaymentDisclosure />} />
            <Route path="/pay/:token" element={<PayPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
